import { FormattedMessage } from 'react-intl';

const ReportsAndDashboards = () => {
	return (
		<div>
			<p>
				<FormattedMessage
					id="JiraSoftwarePricingPageTeam24.features.reportsAndDashboards.content.body"
					defaultMessage="Get insights on teamwork tracked in any Jira product or project."
				/>
			</p>
		</div>
	);
};

export default ReportsAndDashboards;
